import customerInstance from './instance'

const updateCustomer = (options, customerNumber) => {
  return customerInstance.put('/customers/' + customerNumber, options)
}

export default updateCustomer
